import { Controller } from '@hotwired/stimulus'

/**
 * Делает <details> раскрытым на широких экранах и свёрнутым на узких.
 *
 * Нужен для блока оценок в карточке отзыва: на десктопе оценки помещаются
 * рядом с текстом и полезны сразу, а на мобильном занимают половину экрана,
 * поэтому там их прячем под «Show details». Сам <details> остаётся рабочим:
 * пользователь может свернуть или развернуть блок вручную, и после этого
 * контроллер его выбор уже не перебивает.
 */
export default class ResponsiveDetailsController extends Controller {
  static values = { media: { type: String, default: '(min-width: 1024px)' } }

  connect() {
    this.touched = false
    this.onToggle = () => {
      this.touched = true
    }
    this.element.addEventListener('toggle', this.onToggle)

    this.query = window.matchMedia(this.mediaValue)
    this.onChange = () => this.sync()
    this.query.addEventListener('change', this.onChange)

    this.sync()
  }

  disconnect() {
    this.element.removeEventListener('toggle', this.onToggle)
    this.query?.removeEventListener('change', this.onChange)
  }

  sync() {
    if (this.touched) return

    this.element.open = this.query.matches
    // toggle сработает от программного изменения — не считаем это выбором пользователя
    this.touched = false
  }
}
